<template>
  <div 
    class="themed-table-pagination"
    role="navigation"
    aria-label="Table pagination"
  >
    <div class="themed-table-pagination-info">
      <span class="themed-table-pagination-text">
        Showing {{ rangeStart }} to {{ rangeEnd }} of {{ totalItems }} items
      </span>
    </div>
    
    <div class="themed-table-pagination-controls">
      <button
        type="button"
        class="themed-table-pagination-button"
        :disabled="isFirstPage"
        @click="goToFirst"
        @keydown.enter.prevent="goToFirst"
        @keydown.space.prevent="goToFirst"
        title='First'
        :aria-label="'Go to first page'"
        :aria-disabled="isFirstPage ? 'true' : 'false'"
      >
        <theme-icon icon="chevron-double-left" type="icons" classes="w-4 h-4" />
      </button>
      
      <button
        type="button"
        class="themed-table-pagination-button"
        :disabled="isFirstPage"
        @click="goToPrevious"
        @keydown.enter.prevent="goToPrevious"
        @keydown.space.prevent="goToPrevious"
        title='Previous'
        :aria-label="'Go to previous page'"
        :aria-disabled="isFirstPage ? 'true' : 'false'"
      >
        <theme-icon icon="chevron-left" type="icons" classes="w-4 h-4" />
      </button>
      
      <span class="themed-table-pagination-page-info">
        Page {{ current }} of {{ total }}
      </span>
      
      <button
        type="button"
        class="themed-table-pagination-button"
        :disabled="isLastPage"
        @click="goToNext"
        @keydown.enter.prevent="goToNext"
        @keydown.space.prevent="goToNext"
         title='Next'
        :aria-label="'Go to next page'"
        :aria-disabled="isLastPage ? 'true' : 'false'"
      >
        <theme-icon icon="chevron-right" type="icons" classes="w-4 h-4" />
      </button>
      
      <button
        type="button"
        class="themed-table-pagination-button"
        :disabled="isLastPage"
        @click="goToLast"
        @keydown.enter.prevent="goToLast"
        @keydown.space.prevent="goToLast"
        title='Last'
        :aria-label="'Go to last page'"
        :aria-disabled="isLastPage ? 'true' : 'false'"
      >
        <theme-icon icon="chevron-double-right" type="icons" classes="w-4 h-4" />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TablePagination',
  props: {
    current: {
      type: Number,
      required: true,
      validator: (value) => value >= 1
    },
    total: {
      type: Number,
      required: true,
      validator: (value) => value >= 1
    },
    perPage: {
      type: Number,
      required: true,
      validator: (value) => value >= 1
    },
    totalItems: {
      type: Number,
      required: true,
      validator: (value) => value >= 0
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isFirstPage() {
      return this.current === 1 || this.disabled;
    },
    isLastPage() {
      return this.current === this.total || this.disabled;
    },
    rangeStart() {
      if (this.totalItems === 0) {
        return 0;
      }
      return ((this.current - 1) * this.perPage) + 1;
    },
    rangeEnd() {
      const end = this.current * this.perPage;
      return Math.min(end, this.totalItems);
    }
  },
  methods: {
    goToFirst() {
      if (!this.isFirstPage) {
        this.$emit('page-change', 1);
      }
    },
    goToPrevious() {
      if (!this.isFirstPage) {
        this.$emit('page-change', this.current - 1);
      }
    },
    goToNext() {
      if (!this.isLastPage) {
        this.$emit('page-change', this.current + 1);
      }
    },
    goToLast() {
      if (!this.isLastPage) {
        this.$emit('page-change', this.total);
      }
    }
  }
}
</script>
